module.exports = __webpack_public_path__ + "RMR TRN Enrollment Guide.pdf";